// extracted by mini-css-extract-plugin
module.exports = {"wrapperPopup":"SearchPopup_wrapperPopup__pOekX","overlayPopup":"SearchPopup_overlayPopup__U5p3N","root":"SearchPopup_root__g11TO","search":"SearchPopup_search__oCKRo"};